import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

/////////////////////////////////////////////////////////////////////
// Image detail load

export const BLOGS_IMAGE_DETAIL_FETCH_TRIGGER = 'BLOGS_IMAGE_DETAIL_FETCH_TRIGGER';
export interface BlogsImageDetailFetchTriggerAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_FETCH_TRIGGER;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
}
export const BLOGS_IMAGE_DETAIL_FETCH_REQUEST = 'BLOGS_IMAGE_DETAIL_FETCH_REQUEST';
export interface BlogsImageDetailFetchRequestAction extends APIRequestAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_FETCH_REQUEST;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
}
export interface BlogsImageDetailFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        post: number;
        comments: number[];
        moderators: number[];
    };
}
export const BLOGS_IMAGE_DETAIL_FETCH_SUCCESS = 'BLOGS_IMAGE_DETAIL_FETCH_SUCCESS';
export interface BlogsImageDetailFetchSuccessAction extends APISuccessAction<BlogsImageDetailFetchNormalizedResponse> {
    readonly type: typeof BLOGS_IMAGE_DETAIL_FETCH_SUCCESS;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
    readonly isTiedToPost: boolean;
    readonly canAdd: boolean;
}
export const BLOGS_IMAGE_DETAIL_FETCH_FAILURE = 'BLOGS_IMAGE_DETAIL_FETCH_FAILURE';
export interface BlogsImageDetailFetchFailureAction extends APIFailureAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_FETCH_FAILURE;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
}

export const blogsImageDetailFetchTrigger =
    (username: string, postSlug: string, imageId: number): BlogsImageDetailFetchTriggerAction => ({
        type: BLOGS_IMAGE_DETAIL_FETCH_TRIGGER, username, postSlug, imageId,
    });
export const blogsImageDetailFetchApi = {
    request: (username: string, postSlug: string, imageId: number): BlogsImageDetailFetchRequestAction => ({
        type: BLOGS_IMAGE_DETAIL_FETCH_REQUEST,
        username, postSlug, imageId,
    }),
    success: (
        username: string, postSlug: string, imageId: number,
        response: BlogsImageDetailFetchNormalizedResponse, isTiedToPost: boolean, canAdd: boolean,
    ): BlogsImageDetailFetchSuccessAction => ({
        type: BLOGS_IMAGE_DETAIL_FETCH_SUCCESS,
        username, postSlug, imageId, response, isTiedToPost, canAdd,
    }),
    failure: (username: string, postSlug: string, imageId: number, error: any): BlogsImageDetailFetchFailureAction => ({
        type: BLOGS_IMAGE_DETAIL_FETCH_FAILURE,
        username, postSlug, imageId, error,
    }),
};

/////////////////////////////////////////////////////////////////////
// Image detail rotate image

export const BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_TRIGGER = 'BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_TRIGGER';
export interface BlogsImageDetailRotateImageTriggerAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_TRIGGER;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
    readonly angle: number;
}
export const BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_REQUEST = 'BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_REQUEST';
export interface BlogsImageDetailRotateImageRequestAction extends APIRequestAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_REQUEST;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
    readonly angle: number;
}
export interface BlogsImageDetailRotateImageNormalizedResponse extends NormalizedResponse {
    readonly result: {
        image: number;
    };
}
export const BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_SUCCESS = 'BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_SUCCESS';
export interface BlogsImageDetailRotateImageSuccessAction extends APISuccessAction<BlogsImageDetailRotateImageNormalizedResponse> {
    readonly type: typeof BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_SUCCESS;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
    readonly angle: number;
}
export const BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_FAILURE = 'BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_FAILURE';
export interface BlogsImageDetailRotateImageFailureAction extends APIFailureAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_FAILURE;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
    readonly angle: number;
}

export const blogsImageDetailRotateImageTrigger = (username: string, postSlug: string, imageId: number, angle: number): BlogsImageDetailRotateImageTriggerAction => ({
    type: BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_TRIGGER, username, postSlug, imageId, angle,
});
export const blogsImageDetailRotateImageApi = {
    request: (username: string, postSlug: string, imageId: number, angle: number): BlogsImageDetailRotateImageRequestAction => ({
        type: BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_REQUEST, username, postSlug, imageId, angle,
    }),
    success: (
        username: string, postSlug: string, imageId: number, angle: number,
        response: BlogsImageDetailRotateImageNormalizedResponse,
    ): BlogsImageDetailRotateImageSuccessAction => ({
        type: BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_SUCCESS, username, postSlug, imageId, angle, response,
    }),
    failure: (username: string, postSlug: string, imageId: number, angle: number, error: any): BlogsImageDetailRotateImageFailureAction => ({
        type: BLOGS_IMAGE_DETAIL_ROTATE_IMAGE_FAILURE, username, postSlug, imageId, angle, error,
    }),
};

/////////////////////////////////////////////////////////////////////
// Image detail delete image

export const BLOGS_IMAGE_DETAIL_DELETE_IMAGE_TRIGGER = 'BLOGS_IMAGE_DETAIL_DELETE_IMAGE_TRIGGER';
export interface BlogsImageDetailDeleteImageTriggerAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_DELETE_IMAGE_TRIGGER;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
}
export const BLOGS_IMAGE_DETAIL_DELETE_IMAGE_REQUEST = 'BLOGS_IMAGE_DETAIL_DELETE_IMAGE_REQUEST';
export interface BlogsImageDetailDeleteImageRequestAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_DELETE_IMAGE_REQUEST;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
}
export interface BlogsImageDetailDeleteImageNormalizedResponse extends NormalizedResponse {
    readonly result: {
        post: number;
    };
}
export const BLOGS_IMAGE_DETAIL_DELETE_IMAGE_SUCCESS = 'BLOGS_IMAGE_DETAIL_DELETE_IMAGE_SUCCESS';
export interface BlogsImageDetailDeleteImageSuccessAction extends APISuccessAction<BlogsImageDetailDeleteImageNormalizedResponse> {
    readonly type: typeof BLOGS_IMAGE_DETAIL_DELETE_IMAGE_SUCCESS;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
}
export const BLOGS_IMAGE_DETAIL_DELETE_IMAGE_FAILURE = 'BLOGS_IMAGE_DETAIL_DELETE_IMAGE_FAILURE';
export interface BlogsImageDetailDeleteImageFailureAction extends APIFailureAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_DELETE_IMAGE_FAILURE;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
}

export const blogsImageDetailDeleteImageTrigger = (username: string, postSlug: string, imageId: number): BlogsImageDetailDeleteImageTriggerAction => ({
    type: BLOGS_IMAGE_DETAIL_DELETE_IMAGE_TRIGGER, username, postSlug, imageId,
});
export const blogsImageDetailDeleteImageApi = {
    request: (username: string, postSlug: string, imageId: number): BlogsImageDetailDeleteImageRequestAction => ({
        type: BLOGS_IMAGE_DETAIL_DELETE_IMAGE_REQUEST, username, postSlug, imageId,
    }),
    success: (
        username: string, postSlug: string, imageId: number,
        response: BlogsImageDetailDeleteImageNormalizedResponse,
    ): BlogsImageDetailDeleteImageSuccessAction => ({
        type: BLOGS_IMAGE_DETAIL_DELETE_IMAGE_SUCCESS, username, postSlug, imageId, response,
    }),
    failure: (username: string, postSlug: string, imageId: number, error: any): BlogsImageDetailDeleteImageFailureAction => ({
        type: BLOGS_IMAGE_DETAIL_DELETE_IMAGE_FAILURE, username, postSlug, imageId, error,
    }),
};

/////////////////////////////////////////////////////////////////////
// Image detail change title editing state

export const BLOGS_IMAGE_DETAIL_TITLE_EDIT = 'BLOGS_IMAGE_DETAIL_TITLE_EDIT';
export interface BlogsImageDetailTitleEditAction extends Action {
    readonly type: typeof BLOGS_IMAGE_DETAIL_TITLE_EDIT;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
    readonly enabled: boolean;
}
export const blogsImageDetailTitleEdit = (username: string, postSlug: string, imageId: number, enabled: boolean): BlogsImageDetailTitleEditAction => ({
    type: BLOGS_IMAGE_DETAIL_TITLE_EDIT, username, postSlug, imageId, enabled,
});

/////////////////////////////////////////////////////////////////////
// Image detail save title

export const BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_TRIGGER = 'BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_TRIGGER';
export interface BlogsImageDetailSaveImageTitleTriggerAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_TRIGGER;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
    readonly title: string;
}
export const BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_REQUEST = 'BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_REQUEST';
export interface BlogsImageDetailSaveImageTitleRequestAction extends APIRequestAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_REQUEST;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
    readonly title: string;
}
export interface BlogsImageDetailSaveImageTitleNormalizedResponse extends NormalizedResponse {
    readonly result: {
        image: number;
    };
}
export const BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_SUCCESS = 'BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_SUCCESS';
export interface BlogsImageDetailSaveImageTitleSuccessAction extends APISuccessAction<BlogsImageDetailSaveImageTitleNormalizedResponse> {
    readonly type: typeof BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_SUCCESS;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
    readonly title: string;
}
export const BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_FAILURE = 'BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_FAILURE';
export interface BlogsImageDetailSaveImageTitleFailureAction extends APIFailureAction {
    readonly type: typeof BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_FAILURE;
    readonly username: string;
    readonly postSlug: string;
    readonly imageId: number;
    readonly title: string;
}

export const blogsImageDetailSaveImageTitleTrigger = (username: string, postSlug: string, imageId: number, title: string): BlogsImageDetailSaveImageTitleTriggerAction => ({
    type: BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_TRIGGER, username, postSlug, imageId, title,
});
export const blogsImageDetailSaveImageTitleApi = {
    request: (username: string, postSlug: string, imageId: number, title: string): BlogsImageDetailSaveImageTitleRequestAction => ({
        type: BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_REQUEST, username, postSlug, imageId, title,
    }),
    success: (
        username: string, postSlug: string, imageId: number, title: string,
        response: BlogsImageDetailSaveImageTitleNormalizedResponse,
    ): BlogsImageDetailSaveImageTitleSuccessAction => ({
        type: BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_SUCCESS, username, postSlug, imageId, title, response,
    }),
    failure: (username: string, postSlug: string, imageId: number, title: string, error: any): BlogsImageDetailSaveImageTitleFailureAction => ({
        type: BLOGS_IMAGE_DETAIL_SAVE_IMAGE_TITLE_FAILURE, username, postSlug, imageId, title, error,
    }),
};
